var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 86,
    viewBox: "0 0 104 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 11.0001,
    r: 11,
    fill: "#000000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.2049,
    cy: 43.1187,
    r: 4.15994,
    fill: "#000000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.992,
    cy: 6.77335,
    r: 2.77329,
    fill: "#000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.8706 73.138C109.931 100.957 112.559 148.688 84.7401 179.749C56.9211 210.809 9.18992 213.437 -21.8706 185.618C-52.9311 157.799 -55.559 110.068 -27.7401 79.0074C-14.3975 64.1102 3.52554 55.7534 21.993 54.1594C26.2912 53.7885 29.8346 50.3474 29.8264 46.0332L29.8232 44.3418C29.8192 42.2738 28.4959 40.4885 26.936 39.1309C22.4553 35.2312 21.9843 28.4375 25.8839 23.9568C29.7836 19.4761 36.5772 19.0051 41.0579 22.9047C45.5387 26.8044 46.0097 33.598 42.11 38.0787C41.7779 38.4603 41.4248 38.8129 41.054 39.1361C38.4051 41.4445 35.5739 44.264 35.5806 47.7776C35.5875 51.4237 38.3736 54.4312 41.9619 55.0778C55.255 57.4733 68.0706 63.4651 78.8706 73.138Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBubbles);
export default __webpack_public_path__ + "static/media/warning-bubbles.1d54e863e3fc8fd6556c430ff41b8974.svg";
export { ForwardRef as ReactComponent };